import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import VehicleCard from 'components/O2O/VehicleCard';
import Layout from 'components/Layout';
import { colors } from 'components/styles/variables';

const vehicles = [
  {
    dealer: {
      name: 'Irvine Ford of Irvine',
      phone: '(555) 555-5555',
      addressLine1: '885 N. Jamboree',
      addressLine2: 'Irvine, CA 94401',
    },
    lastUpdated: 'Wed, Oct 15, 2024',
    make: 'Ford',
    model: 'F-150',
    trim: 'SVT Raptor',
    year: '2012',
    mileage: '103,945',
    askingPrice: '$26,249',
    availability: 'pending',
    price: 'pending',
    status: 'default',
  },
  {
    dealer: {
      name: 'Irvine Ford of Irvine',
      phone: '(555) 555-5555',
      addressLine1: '885 N. Jamboree',
      addressLine2: 'Irvine, CA 94401',
    },
    lastUpdated: 'Wed, Oct 15, 2024',
    make: 'Ford',
    model: 'F-150',
    trim: 'SVT Raptor',
    year: '2012',
    mileage: '103,945',
    askingPrice: '$26,249',
    availability: 'available',
    price: 'pending',
    status: 'available',
  },
  {
    dealer: {
      name: 'Irvine Ford of Irvine',
      phone: '(555) 555-5555',
      addressLine1: '885 N. Jamboree',
      addressLine2: 'Irvine, CA 94401',
    },
    lastUpdated: 'Wed, Oct 15, 2024',
    make: 'Ford',
    model: 'F-150',
    trim: 'SVT Raptor',
    year: '2012',
    mileage: '103,945',
    askingPrice: '$26,249',
    availability: 'available',
    price: '$25,453',
    status: 'priceConfirmed',
  },
  {
    dealer: {
      name: 'Irvine Ford of Irvine',
      phone: '(555) 555-5555',
      addressLine1: '885 N. Jamboree',
      addressLine2: 'Irvine, CA 94401',
    },
    lastUpdated: 'Wed, Oct 15, 2024',
    make: 'Ford',
    model: 'F-150',
    trim: 'SVT Raptor',
    year: '2012',
    mileage: '103,945',
    askingPrice: '$26,249',
    availability: 'unavailable',
    status: 'unavailable',
  },
  {
    dealer: {
      name: 'Irvine Ford of Irvine',
      phone: '(555) 555-5555',
      addressLine1: '885 N. Jamboree',
      addressLine2: 'Irvine, CA 94401',
    },
    lastUpdated: 'Wed, Oct 15, 2024',
    make: 'Ford',
    model: 'F-150',
    trim: 'SVT Raptor',
    year: '2012',
    mileage: '103,945',
    askingPrice: '$26,249',
    availability: 'pending',
    price: 'pending',
    priceRequest: '$25,000',
    status: 'priceDropRequested',
  },
  {
    dealer: {
      name: 'Irvine Ford of Irvine',
      phone: '(555) 555-5555',
      addressLine1: '885 N. Jamboree',
      addressLine2: 'Irvine, CA 94401',
    },
    lastUpdated: 'Wed, Oct 15, 2024',
    make: 'Ford',
    model: 'F-150',
    trim: 'SVT Raptor',
    year: '2012',
    mileage: '103,945',
    askingPrice: '$26,249',
    availability: 'available',
    price: 'pending',
    priceRequest: '$25,000',
    status: 'available',
  },
  {
    dealer: {
      name: 'Irvine Ford of Irvine',
      phone: '(555) 555-5555',
      addressLine1: '885 N. Jamboree',
      addressLine2: 'Irvine, CA 94401',
    },
    lastUpdated: 'Wed, Oct 15, 2024',
    make: 'Ford',
    model: 'F-150',
    trim: 'SVT Raptor',
    year: '2012',
    mileage: '103,945',
    askingPrice: '$26,249',
    availability: 'available',
    price: 'rejected',
    status: 'priceConfirmed',
  },
  {
    dealer: {
      name: 'Irvine Ford of Irvine',
      phone: '(555) 555-5555',
      addressLine1: '885 N. Jamboree',
      addressLine2: 'Irvine, CA 94401',
    },
    lastUpdated: 'Wed, Oct 15, 2024',
    make: 'Ford',
    model: 'F-150',
    trim: 'SVT Raptor',
    year: '2012',
    mileage: '103,945',
    askingPrice: '$26,249',
    availability: 'available',
    price: 'accepted',
    acceptedPrice: '$26,000',
    status: 'availablePriceDropAccepted',
  },
];

export default function ContactedPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      <Layout
        footer={<div />}
        title={t(`main.meta.pageTitle`)}
        description={t(`main.meta.metaDescription`)}
        indexed={false}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            padding: '12px 8px',
            background: colors.BLACK,
            color: colors.WHITE,
            fontWeight: 600,
          }}
        >
          You have 1 open request
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <VehicleCard {...vehicles[0]} />
          <VehicleCard {...vehicles[1]} />
          <VehicleCard {...vehicles[2]} />
          <VehicleCard {...vehicles[3]} />
          <VehicleCard {...vehicles[4]} />
          <VehicleCard {...vehicles[5]} />
          <VehicleCard {...vehicles[6]} />
          <VehicleCard {...vehicles[7]} />
        </div>
      </Layout>
    </>
  );
}
